import React, { useEffect, useState } from "react";
import { PopularGameList } from "@nestcoinco/hyper-api-gateway-api-client";

import "./MostPopularGamesSection.scss";
import { handleGetPopularGames } from "../../../../api-clients/gamesClient";
import Skeleton from "../../../Skeleton/Skeleton";
import GameTile from "../../GameTile/GameTile";
import { useTranslation } from "react-i18next";

export function GamesLoadingSkeleton() {
  return (
    <div className="px-3 mb-3">
      <Skeleton height={14} width={144} className="mb-4" />
      <div className="d-flex justify-content-between">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i}>
            <Skeleton className="mb-2" height={100} width={100} />
            <Skeleton className="mb-1" height={11} width={83} />
            <Skeleton height={11} width={30} />
          </div>
        ))}
      </div>
    </div>
  );
}

const MAX_POPULAR_GAMES = 3;

function MostPopularGamesSection() {
  const { t } = useTranslation("dashboard");
  const [popularGames, setPopularGames] = useState<PopularGameList>();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const games = await handleGetPopularGames({ limit: MAX_POPULAR_GAMES });
      setPopularGames(games);
      setIsLoading(false);
    })();
  }, []);

  if (isLoading) return <GamesLoadingSkeleton />;

  return (
    <section className="most-popular-games-section px-3">
      <h2 className="heading">{t("most_popular_games")}</h2>
      <div className="popular-games-container">
        {popularGames?.records &&
          popularGames.records
            .slice(0, MAX_POPULAR_GAMES)
            .map(({ game: { name, slug, thumbnail, playCount } }) => (
              <GameTile
                key={name}
                name={name}
                slug={slug}
                thumbnail={thumbnail}
                playCount={playCount}
              />
            ))}
      </div>
    </section>
  );
}

export default MostPopularGamesSection;
